import Checkmark from "./SVG/checkmark.svg?react";

const CheckmarkIcon = () => {
  return <Checkmark data-testid="checkmark-icon" />;
};

export default CheckmarkIcon;
